/* This example requires Tailwind CSS v2.0+ */
import { Primary } from "../buttons/Primary";

export function Space() {
  return (
    <div className="relative font-walsheim text-white">
      <div className="z-0 h-screen bg-tdark xl:mt-10">
        <img className="absolute inset-x-0 bottom-0" src="/png/space.png" alt="Galilea-space"/>
      </div>
      <div className="z-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-2/3 lg:max-w-5xl h-128 py-20 px-0 lg:px-8 pt-28">
        <div className="text-center">
          <div className="">
            <h2 className="text-4xl font-bold tracking-tight sm:text-5xl">
              Construyendo inclusión financiera a través de productos y
              servicios digitales
            </h2>
          </div>
          <div className="my-10 mx-0 lg:mx-20 text-lg sm:text-xl text-grayP">
            En Galilea estamos cambiando la forma en la que las personas se
            relacionan con los servicios financieros.
          </div>
          <div className="my-10 space-y-10">
            <div className="grid justify-items-center">
              <div className="lg:w-1/2">
                <a href="/registrarse" className="w-52 pb-10 md:mx-0 mx-auto">
                  <Primary text="Solicitar crédito" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
